/* eslint-disable */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from '../components/Container';

import './Company.scss';

function Company({ id, ...props }) {
  const [cUrl1, setCUrl1] = useState('');
  const [cUrl2, setCUrl2] = useState('');

  useEffect(() => {
    const fetchImg = async () => {
      const url1 = await fetch('./assets/images/companies/sportsinfocus.png');
      const url2 = await fetch('./assets/images/companies/flashworks.png');
      Promise.all([url1, url2]).then((res) => {
        res.map(({ url }) => {
          if (url.includes('sportsinfocus')) setCUrl1(url);
          if (url.includes('flashworks')) setCUrl2(url);
        });
      });
    };
    fetchImg();
  }, []);

  return (
    <section id={`${id}-section`} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="var(--dp-dark-2)"
          fillOpacity="1"
          d="M0,128L0,32L36.9,32L36.9,96L73.8,96L73.8,192L110.8,192L110.8,64L147.7,64L147.7,160L184.6,160L184.6,224L221.5,224L221.5,64L258.5,64L258.5,320L295.4,320L295.4,288L332.3,288L332.3,128L369.2,128L369.2,288L406.2,288L406.2,128L443.1,128L443.1,224L480,224L480,192L516.9,192L516.9,192L553.8,192L553.8,256L590.8,256L590.8,96L627.7,96L627.7,192L664.6,192L664.6,32L701.5,32L701.5,64L738.5,64L738.5,224L775.4,224L775.4,64L812.3,64L812.3,160L849.2,160L849.2,160L886.2,160L886.2,320L923.1,320L923.1,128L960,128L960,224L996.9,224L996.9,192L1033.8,192L1033.8,128L1070.8,128L1070.8,192L1107.7,192L1107.7,96L1144.6,96L1144.6,192L1181.5,192L1181.5,256L1218.5,256L1218.5,128L1255.4,128L1255.4,32L1292.3,32L1292.3,192L1329.2,192L1329.2,320L1366.2,320L1366.2,160L1403.1,160L1403.1,288L1440,288L1440,0L1403.1,0L1403.1,0L1366.2,0L1366.2,0L1329.2,0L1329.2,0L1292.3,0L1292.3,0L1255.4,0L1255.4,0L1218.5,0L1218.5,0L1181.5,0L1181.5,0L1144.6,0L1144.6,0L1107.7,0L1107.7,0L1070.8,0L1070.8,0L1033.8,0L1033.8,0L996.9,0L996.9,0L960,0L960,0L923.1,0L923.1,0L886.2,0L886.2,0L849.2,0L849.2,0L812.3,0L812.3,0L775.4,0L775.4,0L738.5,0L738.5,0L701.5,0L701.5,0L664.6,0L664.6,0L627.7,0L627.7,0L590.8,0L590.8,0L553.8,0L553.8,0L516.9,0L516.9,0L480,0L480,0L443.1,0L443.1,0L406.2,0L406.2,0L369.2,0L369.2,0L332.3,0L332.3,0L295.4,0L295.4,0L258.5,0L258.5,0L221.5,0L221.5,0L184.6,0L184.6,0L147.7,0L147.7,0L110.8,0L110.8,0L73.8,0L73.8,0L36.9,0L36.9,0L0,0L0,0Z"
        ></path>
      </svg>
      <Container
        id={id}
        description="I'm proud to have collaborated with some awesome companies"
        headerClassName="mb-5"
        className="py-4"
      >
        <div className="d-flex align-items-center col-12 justify-content-center text-center">
          <div className="col-6 col-md-4 col-lg-3 col-xl-2 m-3">
            <a target="_blank" href="https://www.sportsinfocus.com.au/">
              <img
                className="img-fluid"
                src={cUrl1}
                alt="Sports In Focus"
                title="Sports In Focus"
              />
            </a>
          </div>
          <div className="col-2 col-md-2 col-lg-2 col-xl-2 m-3">
            <a target="_blank" href="https://flashworks.io/">
              <img
                className="img-fluid"
                src={cUrl2}
                alt="Flashworks"
                title="Flashworks"
              />
            </a>
          </div>
        </div>
      </Container>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="var(--dp-dark-2)"
          fillOpacity="1"
          d="M0,128L0,32L36.9,32L36.9,96L73.8,96L73.8,192L110.8,192L110.8,64L147.7,64L147.7,160L184.6,160L184.6,224L221.5,224L221.5,64L258.5,64L258.5,320L295.4,320L295.4,288L332.3,288L332.3,128L369.2,128L369.2,288L406.2,288L406.2,128L443.1,128L443.1,224L480,224L480,192L516.9,192L516.9,192L553.8,192L553.8,256L590.8,256L590.8,96L627.7,96L627.7,192L664.6,192L664.6,32L701.5,32L701.5,64L738.5,64L738.5,224L775.4,224L775.4,64L812.3,64L812.3,160L849.2,160L849.2,160L886.2,160L886.2,320L923.1,320L923.1,128L960,128L960,224L996.9,224L996.9,192L1033.8,192L1033.8,128L1070.8,128L1070.8,192L1107.7,192L1107.7,96L1144.6,96L1144.6,192L1181.5,192L1181.5,256L1218.5,256L1218.5,128L1255.4,128L1255.4,32L1292.3,32L1292.3,192L1329.2,192L1329.2,320L1366.2,320L1366.2,160L1403.1,160L1403.1,288L1440,288L1440,320L1403.1,320L1403.1,320L1366.2,320L1366.2,320L1329.2,320L1329.2,320L1292.3,320L1292.3,320L1255.4,320L1255.4,320L1218.5,320L1218.5,320L1181.5,320L1181.5,320L1144.6,320L1144.6,320L1107.7,320L1107.7,320L1070.8,320L1070.8,320L1033.8,320L1033.8,320L996.9,320L996.9,320L960,320L960,320L923.1,320L923.1,320L886.2,320L886.2,320L849.2,320L849.2,320L812.3,320L812.3,320L775.4,320L775.4,320L738.5,320L738.5,320L701.5,320L701.5,320L664.6,320L664.6,320L627.7,320L627.7,320L590.8,320L590.8,320L553.8,320L553.8,320L516.9,320L516.9,320L480,320L480,320L443.1,320L443.1,320L406.2,320L406.2,320L369.2,320L369.2,320L332.3,320L332.3,320L295.4,320L295.4,320L258.5,320L258.5,320L221.5,320L221.5,320L184.6,320L184.6,320L147.7,320L147.7,320L110.8,320L110.8,320L73.8,320L73.8,320L36.9,320L36.9,320L0,320L0,320Z"
        ></path>
      </svg>
    </section>
  );
}

Company.defaultProps = {
  id: 'company',
};

Company.propTypes = {
  id: PropTypes.string,
};

export default React.memo(Company, (prev, next) => true);
